<template>
  <div style="background: #FFF; padding: 1rem; border: 1px solid #AAA;">
    <span>{{ item.name }}</span>
  </div>
</template>

<script>
  export default {
    name: "LabInvoiceDetailAddSuggestList",
    props: {
      item: { required: true },
      searchText: { required: true }
    }
  }
</script>

<style scoped>

</style>
